import { SearchField, DateRange, Field, Filter, GroupCheckbox, Button } from "components/commons";
import { Products } from "enums";
import React from "react";
import { prettifyProduct } from "utils/pretty.utils";
import styles from "./transaction-history-filter.module.scss";
import locale from "localization";
import classNames from "classnames";
import { useMemo } from "react";

const TransactionHistoryFilter = ({
  filterState,
  applyFilter,
  applyClearFilter,
  applyResetFilter,
  modifyFilter,
  modifySearch,
  applySearch,
  applyClearSearch,
  searchKey,
  filterCount,
  exportReport,
  exporting,
}) => {
  const isFormValid = useMemo(() => {
    if (filterState.productCodes?.length) {
      return true;
    }
    return false;
  }, [filterState.productCodes]);

  return (
    <div className={styles.filter}>
      <Filter
        submit={applyFilter}
        clear={applyClearFilter}
        close={applyResetFilter}
        filterCount={filterCount}
        disabled={!isFormValid}
      >
        <Field className={styles.date} label={locale.transactionDate} labelPosition="left">
          <DateRange
            className={styles.dateRange}
            value={{
              startDate: filterState.startDate,
              endDate: filterState.endDate,
            }}
            onChange={(_, { value }) => {
              const { startDate, endDate } = value;
              modifyFilter({
                startDate,
                endDate,
              });
            }}
          />
        </Field>

        <GroupCheckbox
          className={styles.productCode}
          title={locale.products}
          name={"productCodes"}
          options={[
            {
              content: (
                <div className="flex items-center">
                  <div className={classNames(styles.circle, styles.diesel)}></div>
                  {prettifyProduct(Products.Diesel)}
                </div>
              ),
              value: Products.Diesel,
            },
            {
              content: (
                <div className="flex items-center">
                  <div className={classNames(styles.circle, styles.gas91)}></div>
                  {prettifyProduct(Products.Gas91)}
                </div>
              ),
              value: Products.Gas91,
            },
            {
              content: (
                <div className="flex items-center">
                  <div className={classNames(styles.circle, styles.gas95)}></div>
                  {prettifyProduct(Products.Gas95)}
                </div>
              ),
              value: Products.Gas95,
            },
            {
              content: (
                <div className="flex items-center">
                  <div className={classNames(styles.circle, styles.gas97)}></div>
                  {prettifyProduct(Products.Gas97)}
                </div>
              ),
              value: Products.Gas97,
            },
            {
              content: (
                <div className="flex items-center">
                  <div className={classNames(styles.circle, styles.gas97)}></div>
                  {prettifyProduct(Products.Lubserv)}
                </div>
              ),
              value: Products.Lubserv,
            },
            {
              content: (
                <div className="flex items-center">
                  <div className={classNames(styles.circle, styles.gas97)}></div>
                  {prettifyProduct(Products.Lubricants)}
                </div>
              ),
              value: Products.Lubricants,
            },
            {
              content: (
                <div className="flex items-center">
                  <div className={classNames(styles.circle, styles.gas97)}></div>
                  {prettifyProduct(Products.Seagas)}
                </div>
              ),
              value: Products.Seagas,
            },
          ]}
          value={filterState.productCodes}
          onChange={(name, { value }) => {
            modifyFilter({ [name]: value });
          }}
        />
      </Filter>
      <Field className={styles.search}>
        <SearchField
          restrict={false}
          placeholder={[locale.searchInAwardPointsHistory]}
          value={searchKey}
          onChange={(_, { value }) => {
            return modifySearch(value);
          }}
          onEnter={applySearch}
          onClear={applyClearSearch}
        />
      </Field>
      <Field className={styles.downloadButton}>
        <Button
          startIcon={<span className="icon-download" />}
          exportButton
          onClick={exportReport}
          disabled={exporting}
          loading={exporting}
        >
          {locale.export}
        </Button>
      </Field>
    </div>
  );
};

export default TransactionHistoryFilter;
